import { render, staticRenderFns } from "./app-install-panel.vue?vue&type=template&id=4036ecc0&scoped=true&"
import script from "./app-install-panel.vue?vue&type=script&lang=js&"
export * from "./app-install-panel.vue?vue&type=script&lang=js&"
import style0 from "./app-install-panel.vue?vue&type=style&index=0&id=4036ecc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036ecc0",
  null
  
)

export default component.exports